module.exports = __webpack_public_path__ + "img/nphcda_small_logo.d5bf84d1.jpeg";